export const COLEGIOS_NOTARIALES_URL = 'https://notariado.org';
export const NOTARIOS_ESPAÑA_URL = 'https://notariado.org';
